import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fr-error-base',
  templateUrl: './error-base.component.html',
  styleUrls: ['./error-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorBaseComponent {}
